var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulbOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00002 19.9998H11V17.9998H5.00002V19.9998ZM6.54 0.149789C3.79002 0.709789 1.60002 2.95979 1.11002 5.72979C0.600019 8.6198 1.87002 11.2498 4.00002 12.7398V15.9998H12V12.7398C13.81 11.4698 15 9.3798 15 6.99979C15 2.65979 11.03 -0.770211 6.54 0.149789ZM10.85 11.0998L10 11.6998V13.9998H6V11.6998L5.15002 11.0998C3.80002 10.1598 3.00002 8.6298 3.00002 6.99979C3.00002 4.23979 5.24002 1.99979 8 1.99979C10.76 1.99979 13 4.23979 13 6.99979C13 8.6298 12.2 10.1598 10.85 11.0998Z",
    fill: "#031C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbOutline);
export default __webpack_public_path__ + "static/media/lightbulb_outline.33ef830141d9cd5dac9406bb4c0b2c82.svg";
export { ForwardRef as ReactComponent };